<template>
<div>
    <div id="loading_wrap" class="loading-wrap" v-show="PageLoading">
        <div class="la-ball-spin la-2x">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
    <div id="load_error" class="load-error" v-if="error">
        <div class="load-error-inner">
            <img src="http://7xte9b.com2.z0.glb.qiniucdn.com/o_1duhf02l1q251gqq1dslord1vvna.png" alt="">
            <span id="reload_btn" class="reload-btn">
                <img src="http://7xte9b.com2.z0.glb.qiniucdn.com/o_1duhf02l1sfp10cskbf19jr1kdbb.png" alt="">
            </span>
        </div>       
    </div>
</div>
</template>


<script>
export default {
    name: 'Loading',
	data() {
		return {
			PageLoading: true,
			error: true
		};
	},
	mounted() { 
		this.loading = false;
		/*var timeoutIds = setTimeout(function(){
            if (!!(window.attachEvent && !window.opera)) { 
                document.execCommand("stop");
            }else{ 
                window.stop();
            }
            document.getElementById('load_error').style.display = 'block';
            document.getElementById('loading_wrap').style.display = 'none';
        }, 30000);
        document.getElementById('reload_btn').addEventListener('click', function(){
            location.reload()
        }, false);*/
	},
	methods: {
	
	}
}

</script>


<style lang="less" scoped>
    .loading-wrap {
            position: fixed;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            z-index: 20;
        }
        .la-ball-spin,.la-ball-spin>div {
            position: relative;
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box
        }

        .la-ball-spin {
            display: block;
            font-size: 0;
            color: #f0523f;
        }

        .la-ball-spin>div {
            display: inline-block;
            float: none;
            background-color: currentColor;
            border: 0 solid currentColor
        }

        .la-ball-spin {
            width: 1.030596rem;
            height: 1.030596rem;
            margin: 0 auto;
            position: relative;
            top: 50%;
            transform: translateY(-50%);
        }

        .la-ball-spin>div {
            position: absolute;
            top: 50%;
            left: 50%;
            width: .257649rem;
            height: .257649rem;
            margin-top: -0.128824rem;
            margin-left: -0.128824rem;
            border-radius: 100%;
            animation: ball-spin 1s infinite ease-in-out
        }

        .la-ball-spin>div:nth-child(1) {
            top: 5%;
            left: 50%;
            animation-delay: -1.125s
        }

        .la-ball-spin>div:nth-child(2) {
            top: 18.1801948466%;
            left: 81.8198051534%;
            animation-delay: -1.25s
        }

        .la-ball-spin>div:nth-child(3) {
            top: 50%;
            left: 95%;
            animation-delay: -1.375s
        }

        .la-ball-spin>div:nth-child(4) {
            top: 81.8198051534%;
            left: 81.8198051534%;
            animation-delay: -1.5s
        }

        .la-ball-spin>div:nth-child(5) {
            top: 94.9999999966%;
            left: 50.0000000005%;
            animation-delay: -1.625s
        }

        .la-ball-spin>div:nth-child(6) {
            top: 81.8198046966%;
            left: 18.1801949248%;
            animation-delay: -1.75s
        }

        .la-ball-spin>div:nth-child(7) {
            top: 49.9999750815%;
            left: 5.0000051215%;
            animation-delay: -1.875s
        }

        .la-ball-spin>div:nth-child(8) {
            top: 18.179464974%;
            left: 18.1803700518%;
            animation-delay: -2s
        }


        @keyframes ball-spin {
            0%,100% {
                opacity: 1;
                -webkit-transform: scale(1);
                -moz-transform: scale(1);
                -o-transform: scale(1);
                transform: scale(1)
            }

            20% {
                opacity: 1
            }

            80% {
                opacity: 0;
                -webkit-transform: scale(0);
                -moz-transform: scale(0);
                -o-transform: scale(0);
                transform: scale(0)
            }
        }
        .load-error {
			display: none;
            position: fixed;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            z-index: 21;
            font-size: 0;
        }
        .load-error-inner {
            width: 40%;
            position: relative;
            left: 20%;
            top: 50%;
            -webkit-transform: translateY(-50%);
            transform: translateY(-50%);
            background-color: #fff;
            padding: 6% 10%;
            border-radius: 20px;
        }
        .reload-btn {
            display: block;
            cursor: pointer;
        }
</style>